// eslint-disable-next-line import/prefer-default-export
export const isValid = str => {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}
